import axios, { AxiosError } from "axios";
import { reportSchemaFailure } from "_shared/_errors/client-error-reporter";

export class InvalidURLError extends Error {
  constructor(url: string) {
    super(`Invalid URL: ${url}`);
  }
}

export function assertIsAxiosError(error: unknown): asserts error is AxiosError {
  if (!axios.isAxiosError(error)) {
    reportSchemaFailure({
      schemaName: "AxiosError",
      operation: "api-error-adapter",
      phase: "classify",
      fields: [],
    });
    throw new Error("A non-network-related error occurred.");
  }
}
